import React, { useMemo } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { StylesProvider, ThemeProvider } from '@material-ui/core/styles';
import { createTheme } from '../../theme';
/**
 *
 * API:
 *
 * - [StyledProvider API](https://components-extra.netlify.app/utils/styled-provider)
 */

var StyledProvider = function StyledProvider(_ref) {
  var children = _ref.children,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      theme = _ref.theme;
  var finalTheme = useMemo(function () {
    return createTheme(dark, theme);
  }, [dark, theme]);
  return React.createElement(StylesProvider, {
    injectFirst: true
  }, React.createElement(ThemeProvider, {
    theme: finalTheme
  }, React.createElement(StyledThemeProvider, {
    theme: finalTheme
  }, children)));
};

export default StyledProvider;